var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { InputAdornment } from '@mui/material';
import { Close12, SearchField16 } from '@yunex/yds-icons';
import React, { useRef } from 'react';
import Button from '../Button';
import MenuItem from '../MenuItem';
import TextField from '../TextField';
var styles = {
    menuItem: {
        bgcolor: 'transparent',
        cursor: 'default',
        height: 'auto',
        '&:hover': {
            bgcolor: 'transparent',
        },
    },
};
/**
 * A filterable menu item. This item needs to be FIRST in the menu.
 */
var MenuFilterInputItem = function (_a) {
    var filterPlaceholderText = _a.filterPlaceholderText, menuItemSx = _a.menuItemSx, menuListRef = _a.menuListRef, nestedMenuRef = _a.nestedMenuRef, searchFieldValue = _a.searchFieldValue, setSearchFieldValue = _a.setSearchFieldValue, textFieldSx = _a.textFieldSx, props = __rest(_a, ["filterPlaceholderText", "menuItemSx", "menuListRef", "nestedMenuRef", "searchFieldValue", "setSearchFieldValue", "textFieldSx"]);
    var filterInputRef = useRef(null);
    var menuItemRef = useRef(null);
    var handleKeyDown = function (e) {
        var _a, _b, _c, _d, _e, _f;
        e.stopPropagation();
        // If menuListRef was not passed we have to find it by query.
        var parent = (menuListRef === null || menuListRef === void 0 ? void 0 : menuListRef.current) || ((_a = menuItemRef.current) === null || _a === void 0 ? void 0 : _a.closest('[role="menu"]'));
        var items = parent === null || parent === void 0 ? void 0 : parent.querySelectorAll("li:not([class*='Subheader'])");
        if (e.key === 'ArrowDown') {
            ;
            (_b = items[1]) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else if (e.key === 'ArrowUp' && items.length > 1) {
            ;
            (_c = items[items.length - 1]) === null || _c === void 0 ? void 0 : _c.focus();
        }
        else if (['Enter', ' ', 'Backspace'].includes(e.key) || e.key.length === 1) {
            (_d = filterInputRef === null || filterInputRef === void 0 ? void 0 : filterInputRef.current) === null || _d === void 0 ? void 0 : _d.focus();
        }
        else if (nestedMenuRef &&
            (e.key === 'Escape' ||
                (e.key === 'ArrowLeft' && ((_e = filterInputRef.current) === null || _e === void 0 ? void 0 : _e.selectionStart) === 0))) {
            (_f = nestedMenuRef === null || nestedMenuRef === void 0 ? void 0 : nestedMenuRef.current) === null || _f === void 0 ? void 0 : _f.focus();
        }
    };
    var handleClearClick = function (e) {
        e.stopPropagation();
        setSearchFieldValue('');
    };
    var handleChange = function (event) {
        setSearchFieldValue(event.target.value);
    };
    var handleClick = function (e) { return e.stopPropagation(); };
    return (React.createElement(MenuItem, __assign({ ref: menuItemRef, onClick: handleClick, onKeyDown: handleKeyDown, sx: __assign(__assign({}, styles.menuItem), menuItemSx) }, props),
        React.createElement(TextField, { InputProps: {
                endAdornment: searchFieldValue.length > 0 && (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(Button, { icon: true, color: "tertiary", onClick: handleClearClick },
                        React.createElement(Close12, null)))),
                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                    React.createElement(SearchField16, null))),
            }, inputRef: filterInputRef, onChange: handleChange, placeholder: filterPlaceholderText, sx: textFieldSx, type: "text", value: searchFieldValue })));
};
export default MenuFilterInputItem;
